/*eslint-disable */
import store from '@/store'

const baseMixins = {
	data() {
		return {};
	},
	methods: {
		isEmpty(val) {
			return this.$XEUtils.isEmpty(val);
		},
		isNotEmpty(val) {
			return !this.isEmpty(val);
		},
		isNotEmptyList(list) {
			return this.$XEUtils.isArray(list) && !this.isEmpty(list);
		},
		getFileUrl(fileId, fileType) {
			let baseUrl = window.configs.REQUEST_BASE_URL;
			let account = `${window.configs.PROJECT_ACCOUNT}/`;
			if (this.isNotEmpty(fileType)) {
				return `${baseUrl}${this.$api.FILE_GetFileWithType}${account}${fileId}.${fileType}`;
			}
			return `${baseUrl}${this.$api.FILE_GetFile}${account}${fileId}`;
		},
		getVideoUrl(fileId) {
			return `${this.$api.FILE_GetVideo}${account}${fileId}`;
		},
		setRefToThis(name, ref) {
			this[name] = ref;
		},
		storeCommit(method, data) {
			return store.commit(method, data);
		},
		storeDispatch(method, data) {
			return store.dispatch(method, data);
		},
		fetchData(url, data = {}, hideErrMsg = false) {
			return store.dispatch('fetchData', {url, data, hideErrMsg});
		},
		resetIndex(datas, field = "_index", baseObj = {}) {
			let list = [];
			if (this.isNotEmptyList(datas)) {
				datas.forEach((item, index) => {
					let obj = $.extend({}, baseObj, item);
					obj[field] = index;
					list.push(obj);
				});
			}
			return list;
		},
		setTableTotal (options, result) {
			let pagination = false;
			if (options.pagination) {
				pagination = $.extend({}, options.pagination);
				pagination.total = result && result.page ? (result.page.totalRows || 0) : 0;
			}
			return $.extend({}, options, {pagination});
		},
		resetTablePagination (options) {
			let pagination = false;
			if (options.pagination) {
				pagination = $.extend({}, options.pagination);
				pagination.pageIndex = 1;
				pagination.total = 0;
			}
			return $.extend({}, options, {pagination});
		},
		getPageParams(tableOptions, searchForm = {}) {
			let queryData = $.extend({}, searchForm);
			if (tableOptions.pagination) {
				queryData = $.extend({}, queryData, {
					pageNo: tableOptions.pagination.pageIndex,
					pageSize: tableOptions.pagination.pageSize,
				});
			}
			return queryData;
		},
	},
};

export default baseMixins;